import moment from 'moment';

export const isIsoDateString = (value: unknown) =>
  typeof value === 'string' && moment(value, moment.ISO_8601, true).isValid();

export const normalizeFilterPayloadDates = (payload: unknown): unknown => {
  if (Array.isArray(payload)) {
    return payload.map((item) => normalizeFilterPayloadDates(item));
  }

  if (payload && typeof payload === 'object') {
    return Object.entries(payload as Record<string, unknown>).reduce(
      (acc, [key, value]) => {
        acc[key] = normalizeFilterPayloadDates(value);
        return acc;
      },
      {} as Record<string, unknown>,
    );
  }

  if (typeof payload === 'string' && isIsoDateString(payload)) {
    return Date.parse(payload);
  }

  return payload;
};

export const getGroupedMetrics = (keyMetrics, keyMetricsGroups) => {
  const getMetricCode = (metric) =>
    metric?.goal_definition_code ||
    metric?.code ||
    metric?.card?.goal_definition_code;
  const groupedCodes = new Set<string>();
  const groups = (keyMetricsGroups || []).map((group) => {
    const goalCodes = group?.goal_definition_code || [];
    const cards = (keyMetrics || []).filter((metric) =>
      goalCodes.includes(getMetricCode(metric)),
    );

    goalCodes.forEach((code) => groupedCodes.add(code));

    return {
      key: group.id,
      label: group.name,
      cards,
    };
  });
  const otherCards = (keyMetrics || []).filter(
    (metric) => !groupedCodes.has(getMetricCode(metric)),
  );

  if (keyMetricsGroups?.length && otherCards.length) {
    groups.push({
      key: 'others',
      label: 'Others',
      cards: otherCards,
    });
  }

  return groups;
};
